import axios from "../../helpers/httpClient";

export default {
    //ACTION SELL
    uploadSell: async ({ commit, dispatch, state }, data) => {
        const stateMovimientosBancos = state.movimientosBancos
        const stateMovimientosCajas = state.movimientosCajas
        const stateMovimientosOtros = state.movimientosOtros
        const stateMovimientosCobrar = state.movimientosCuentasPorCobrar
        const stateData = state.newEntrance;
        const stateDataArticles = state.articles;
        const stateDataServices = state.service;
        const stateDataMovimientsServices = state.serviceMovimientos
        const stateVenta = state.venta
        const stateVentaCount = state.ventaCount
        const stateLastNumberControlVenta = state.lastNumberControlVenta

        try {
            // Start loader
            commit('SET_LOADER', true);

            const sellAnswer = await axios.post(`/information/private/management/sell`, {
                ...data,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (sellAnswer.status === 200) {
                const {venta,movimientoArticuloR,movimientoServiceR,newMovimientoCaja,newMovimientoOtros,newMovimientoBancos,newMovimientoCobrar} = sellAnswer.data.data

                if(data.isEdit){
                    stateVenta.forEach((datas, index) => {
                        if (Number(datas.Id_venta) === Number(venta.Id_venta)) {
                            Object.assign(stateVenta[index], venta)
                        }
                    })
                }else{
                    stateVenta.push(venta)
                }
                const obj = { array: stateVenta, property: ['Monto_factura','Iva_factura']};

                let newStateData = await dispatch('updateAmountWithCurrency', obj);
                if(newMovimientoCobrar){
                    stateMovimientosCobrar.push(newMovimientoCobrar)
                    commit('SET_MOVIMIENTOS_POR_COBRAR', stateMovimientosCobrar);
                    commit('SET_MOVIMIENTOS_POR_COBRAR_FILTRO', stateMovimientosCobrar);
                }
                if(newMovimientoBancos){
                    stateMovimientosBancos.push(newMovimientoBancos);
                    commit('SET_MOVIMIENTOS_BANCOS', stateMovimientosBancos);
                    commit('SET_MOVIMIENTOS_BANCOS_FILTROS', stateMovimientosBancos);
                }
                if(newMovimientoCaja){
                    stateMovimientosCajas.push(newMovimientoCaja);
                    commit('SET_MOVIMIENTOS_CAJAS', stateMovimientosCajas);
                    commit('SET_MOVIMIENTOS_CAJAS_FILTROS', stateMovimientosCajas);
                }
                if(newMovimientoCaja){
                    stateMovimientosCajas.push(newMovimientoCaja);
                    commit('SET_MOVIMIENTOS_CAJAS', stateMovimientosCajas);
                    commit('SET_MOVIMIENTOS_CAJAS_FILTROS', stateMovimientosCajas);
                }
                if(newMovimientoOtros){
                    stateMovimientosOtros.push(newMovimientoOtros);
                    commit('SET_MOVIMIENTOS_OTROS', stateMovimientosOtros);
                }

                movimientoArticuloR.map(e => {
                    const {movement,article} = e;
                    stateData.push(movement)
                    stateDataArticles.forEach((data, index) => {
                        if (data.Id_articulo === article.Id_articulo) {
                            stateDataArticles[index].Cantidad = article.Cantidad
                        }
                    })
                })

                movimientoServiceR.map(e => {
                    const {movement,service} = e;
                    stateDataMovimientsServices.push(movement)
                    stateDataServices.forEach((data,index) => {
                        if(data.id === service.id){
                            stateDataServices[index].cantidad = service.cantidad
                        }
                    })
                })

                commit('SET_NEWENTRANCE', stateData);
                commit('SET_NEWENTRANCE_FILTERED', stateData);

                commit('SET_ARTICLES', stateDataArticles);
                commit('SET_ARTICLES_FILTERED', stateDataArticles);

                commit('SET_SERVICE_MOVIMIENTOS',stateDataMovimientsServices)
                commit('SET_SERVICE_MOVIMIENTOS_FILTROS', stateDataMovimientsServices)

                commit('SET_SERVICE', stateDataServices)
                commit('SET_SERVICE_FILTROS', stateDataServices)

                commit('SET_VENTA', newStateData);
                commit('SET_VENTA_FILTRO', newStateData);
                commit('VENTA_COUNT', Number(stateVentaCount) + 1);
                if(Number(venta.Numero_venta) > Number(stateLastNumberControlVenta)){
                    commit('LAST_NUMBER_CONTROL_VENTA', Number(venta.Numero_venta))
                }

                dispatch('activeMessageCorrect', sellAnswer.data.message)
                return 'ok'

            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    requestSell: async ({ commit, state, dispatch }, page) => {

        try {
            // Start loader
            commit('SET_LOADER', true);

            const ventas = await axios.get(`/information/private/management/getSell`, { params: { page } }, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false)

            if (ventas.status === 200) {
                commit('SET_VENTA', ventas.data.ventas);
                commit('SET_VENTA_FILTRO', ventas.data.ventas);
                commit('VENTA_COUNT', ventas.data.count);
                commit('LAST_NUMBER_CONTROL_VENTA', {
                    f: ventas?.data?.reg?.Numero_factura,
                    c: ventas?.data?.reg?.Numero_control
                });
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    deleteSell: async ({ commit, state, dispatch }, code) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const sellAnswer = await axios.post(`/information/private/management/deleteSell`, {
                code
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (sellAnswer.status === 200) {
                dispatch('activeMessageCorrect', sellAnswer.data.message)
                return 'ok'
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    //ACTION BUY
    uploadBuy: async ({ commit, dispatch, state }, data) => {
        const stateMovimientosBancos = state.movimientosBancos
        const stateMovimientosCajas = state.movimientosCajas
        const stateMovimientosOtros = state.movimientosOtros
        const stateMovimientosPagar = state.movimientosCuentasPorPagar
        const stateData = state.newEntrance;
        const stateDataArticles = state.articles;
        const stateDataServices = state.service;
        const stateDataMovimientsServices = state.serviceMovimientos
        const stateCompra = state.compra
        const stateCompraCount = state.compraCount
        const stateLastNumberControlCompra = state.lastNumberControlCompra

        try {
            // Start loader
            commit('SET_LOADER', true);

            const buyAnswer = await axios.post(`/information/private/management/buy`, {
                ...data,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            

            if (buyAnswer.status === 200) {
                const {compra,movimientoArticuloR,movimientoServiceR,newMovimientoCaja,newMovimientoOtros,newMovimientoBancos,newMovimientoPagar} = buyAnswer.data.data

                if(data.isEdit){
                    stateCompra.forEach((datas, index) => {
                        if (Number(datas.Id_egreso) === Number(compra.Id_egreso)) {
                            Object.assign(stateCompra[index], compra)
                        }
                    })
                }else{
                    stateCompra.push(compra)
                }
                const obj = { array: stateCompra, property: ['Monto_factura','Iva_factura']};

                let newStateData = await dispatch('updateAmountWithCurrency', obj);
                if(newMovimientoBancos){
                    stateMovimientosBancos.push(newMovimientoBancos);
                    commit('SET_MOVIMIENTOS_BANCOS', stateMovimientosBancos);
                    commit('SET_MOVIMIENTOS_BANCOS_FILTROS', stateMovimientosBancos);
                }
                if(newMovimientoCaja){
                    stateMovimientosCajas.push(newMovimientoCaja);
                    commit('SET_MOVIMIENTOS_CAJAS', stateMovimientosCajas);
                    commit('SET_MOVIMIENTOS_CAJAS_FILTROS', stateMovimientosCajas);
                }
                if(newMovimientoCaja){
                    stateMovimientosCajas.push(newMovimientoCaja);
                    commit('SET_MOVIMIENTOS_CAJAS', stateMovimientosCajas);
                    commit('SET_MOVIMIENTOS_CAJAS_FILTROS', stateMovimientosCajas);
                }
                if(newMovimientoOtros){
                    stateMovimientosOtros.push(newMovimientoOtros);
                    commit('SET_MOVIMIENTOS_OTROS', stateMovimientosOtros);
                }
                if(newMovimientoPagar){
                    stateMovimientosPagar.push(newMovimientoPagar)
                    commit('SET_MOVIMIENTOS_POR_PAGAR', stateMovimientosPagar)
                    commit('SET_MOVIMIENTOS_POR_PAGAR_FILTRO', stateMovimientosPagar)
                }

                movimientoArticuloR.map(e => {
                    const {movement,article} = e;
                    stateData.push(movement)
                    stateDataArticles.forEach((data, index) => {
                        if (data.Id_articulo === article.Id_articulo) {
                            stateDataArticles[index].Cantidad = article.Cantidad
                        }
                    })
                })

                movimientoServiceR.map(e => {
                    const {movement,service} = e;
                    stateDataMovimientsServices.push(movement)
                    stateDataServices.forEach((data,index) => {
                        if(data.id === service.id){
                            stateDataServices[index].cantidad = service.cantidad
                        }
                    })
                })

                commit('SET_NEWENTRANCE', stateData);
                commit('SET_NEWENTRANCE_FILTERED', stateData);

                commit('SET_ARTICLES', stateDataArticles);
                commit('SET_ARTICLES_FILTERED', stateDataArticles);

                commit('SET_SERVICE_MOVIMIENTOS',stateDataMovimientsServices)
                commit('SET_SERVICE_MOVIMIENTOS_FILTROS', stateDataMovimientsServices)

                commit('SET_SERVICE', stateDataServices)
                commit('SET_SERVICE_FILTROS', stateDataServices)

                commit('SET_COMPRA', newStateData);
                commit('SET_COMPRA_FILTRO', newStateData);
                commit('COMPRA_COUNT', Number(stateCompraCount) + 1);
                if(Number(compra.Numero_compra) > Number(stateLastNumberControlCompra)){
                    commit('LAST_NUMBER_CONTROL_COMPRA', Number(compra.Numero_compra))
                }

                dispatch('activeMessageCorrect', buyAnswer.data.message)
                return 'ok'

            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    requestBuy: async ({ commit, state, dispatch }, page) => {

        try {
            // Start loader
            commit('SET_LOADER', true);

            const compras = await axios.get(`/information/private/management/getBuys`, {
                params: { page } }, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (compras.status === 200) {
                commit('SET_COMPRA', compras.data.compras);
                commit('SET_COMPRA_FILTRO', compras.data.compras);
                commit('COMPRA_COUNT', compras.data.count);
                commit('LAST_NUMBER_CONTROL_COMPRA', {
                    f: compras?.data?.reg?.Numero_factura,
                    c: compras?.data?.reg?.Numero_control
                });
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    deleteBuy: async ({ commit, state, dispatch }, code) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const buyAnswer = await axios.post(`/information/private/management/deleteBuy`, {
                code
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (buyAnswer.status === 200) {
                dispatch('activeMessageCorrect', buyAnswer.data.message)
                return 'ok'
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    //ACTION CUENTAS POR COBRAR
    requestCuentasPorCobrar: async ({ commit, state, dispatch }, page) => {

        try {
            // Start loader
            commit('SET_LOADER', true);

            const cobrar = await axios.get(`/information/private/management/getMovCuentasPorCobrar`, {
                params: { page } }, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (cobrar.status === 200) {

                const obj = { array: cobrar.data.movimientoCuentasCobrar, property: 'Cantidad'};
                let newStateData = await dispatch('updateAmountWithCurrency', obj);
                commit('SET_MOVIMIENTOS_POR_COBRAR', newStateData);
                commit('SET_MOVIMIENTOS_POR_COBRAR_FILTRO', newStateData);
                commit('MOVIMIENTOS_CUENTAS_POR_COBRAR_COUNT', cobrar.data.count);
            }
        } catch (error) {

            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    //ACTION CUENTAS POR COBRAR
    requestCuentasPorPagar: async ({ commit, state, dispatch }, page) => {

        try {
            // Start loader
            commit('SET_LOADER', true);

            const pagar = await axios.get(`/information/private/management/getMovCuentasPorPagar`, {
                params: { page } }, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (pagar.status === 200) {
                const obj = { array: pagar.data.movimientoCuentasPagar, property: 'Cantidad'};
                let newStateData = await dispatch('updateAmountWithCurrency', obj);
                commit('SET_MOVIMIENTOS_POR_PAGAR', newStateData);
                commit('SET_MOVIMIENTOS_POR_PAGAR_FILTRO', newStateData);
                commit('MOVIMIENTOS_CUENTAS_POR_PAGAR_COUNT', pagar.data.count);
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
}